import { programData } from "@/data/mentors";
import { Navigate, useParams } from "react-router-dom";
import { Users, Lightbulb, CheckCircle2, Video, Play } from "lucide-react";
import { useEffect } from "react";
import Aos from "aos";

export default function DetailSection() {
  const { slug } = useParams();
  useEffect(() => {
    Aos.init({ duration: 1000, once: true });
  }, []);
  const mentor = programData.find((item) => item.slug === slug);

  if (!mentor) {
    return <Navigate to="/Future/FutureMentor" replace />;
  }

  return (
    <div className="w-full mt-28 lg:-mt-8 md:mt-10 sm:mt-4" data-aos="fade-up">
      {/* Image - top right */}
      <div className="flex justify-end -mt-8">
        <div
          className="bg-white aspect-[16/10] rounded-3xl overflow-hidden shrink-0 w-full sm:w-2/4 md:w-1/2 lg:w-1/3"
          data-aos="fade-left"
        >
          <img
            src={mentor.imageSrc || "/placeholder.png"}
            alt={mentor.title}
            className="w-full h-full object-contain"
          />
        </div>
      </div>

      {/* Content - entire section */}
      <div className="relative w-full sm:w-full lg:w-2/3 font-sans overflow-x-hidden -mt-46 lg:-mt-32">
        <div className="bg-transparent pt-2 lg:pr-10">
          <div className="max-w-6xl mx-auto flex flex-col gap-6">
            <div className="bg-white rounded-3xl border border-gray-100 p-6 sm:p-8">
              <div className="flex items-center gap-2 mb-4">
                <Users className="text-[#B70100] w-6 h-6" />
                <h2 className="text-xl font-bold text-gray-900">About Me</h2>
              </div>
              <div className="text-gray-500 text-sm leading-relaxed whitespace-pre-line flex flex-col gap-4">
                {mentor.bio}
              </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              <div className="bg-white rounded-3xl border border-gray-100 p-6 sm:p-8">
                <div className="flex items-center gap-2 mb-5">
                  <Lightbulb className="text-[#B70100] w-6 h-6" />
                  <h2 className="text-xl font-bold text-gray-900">
                    Teaching Style
                  </h2>
                </div>
                <div className="flex flex-col gap-4">
                  {mentor.teachingStyle?.map((point, i) => (
                    <div key={i} className="flex items-start gap-3">
                      <CheckCircle2 className="text-[#B70100] w-5 h-5 shrink-0 mt-0.5" />
                      <p className="text-sm text-gray-600 leading-relaxed">
                        <span className="font-bold text-gray-900">
                          {point.title}:{" "}
                        </span>
                        {point.desc}
                      </p>
                    </div>
                  ))}
                </div>
              </div>

              {/* Introduction Video */}
              <div className="bg-white rounded-3xl border border-gray-100 overflow-hidden flex flex-col">
                <div className="flex items-center gap-2 p-6 sm:p-8 pb-4">
                  <Video className="text-[#B70100] w-6 h-6" />
                  <h2 className="text-xl font-bold text-gray-900">
                    Introduction
                  </h2>
                </div>
                <div className="relative flex-1 bg-[#2b1c19] min-h-[260px] flex items-center justify-center">
                  {mentor.videoThumbnail && (
                    <img
                      src={mentor.videoThumbnail}
                      alt="Video thumbnail"
                      className="absolute inset-0 w-full h-full object-cover opacity-70"
                    />
                  )}
                  <button
                    type="button"
                    className="relative z-10 bg-[#B70100] hover:bg-[#980000] transition-colors w-16 h-16 rounded-full flex items-center justify-center shadow-lg"
                    aria-label="Play introduction video"
                  >
                    <Play className="text-white w-6 h-6 fill-white" />
                  </button>
                </div>
              </div>
            </div>

            {/* Stats + Languages + Book Session */}
            {/* <div className="bg-white rounded-3xl border border-gray-100 p-6 sm:p-8 flex flex-col gap-6">
              <div className="grid grid-cols-2 gap-3">
                <div className="bg-gray-50 rounded-2xl p-4 text-center">
                  <p className="text-xs text-gray-500">Experience</p>
                  <p className="text-base font-bold text-gray-900 mt-1">
                    {mentor.experience}
                  </p>
                </div>
                <div className="bg-gray-50 rounded-2xl p-4 text-center">
                  <p className="text-xs text-gray-500">Students Taught</p>
                  <p className="text-base font-bold text-gray-900 mt-1">
                    {mentor.students}
                  </p>
                </div>
              </div>

              <div>
                <p className="text-xs text-gray-500 mb-2">Languages</p>
                <div className="flex flex-wrap gap-2">
                  {mentor.languages?.map((lang, i) => (
                    <span
                      key={i}
                      className="bg-gray-100 text-gray-700 text-xs font-medium px-3 py-1.5 rounded-full"
                    >
                      {lang}
                    </span>
                  ))}
                </div>
              </div>

              <button className="w-full bg-red-600 hover:bg-red-700 active:bg-red-800 text-white font-semibold text-sm py-3.5 rounded-2xl transition-colors duration-200">
                Book a Session
              </button>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}
